import { lazy } from "react";
import { ElementDetails } from "@/lib/types";

export const details = {
  name: "Pomodoro",
  description: "A Pomodoro timer widget for productivity",
  tags: ["Productivity"],
  category: "Widget",
  setup: lazy(() =>
    import("./Settings").then(m => ({ default: m.PomodoroSettings })),
  ),
  context: lazy(() => import("./Context").then(m => ({ default: m.Context }))),
  grid: { default: [2, 2] },
  defaultProps: {
    sound: "alarm-01",
    focusDuration: 25,
    breakDuration: 5,
    longRestDuration: 15,
    pomodoroCount: 4,
    autoStartFocus: false,
    autoStartBreak: false,
    autoStartLongRest: false,
  },
} satisfies ElementDetails;
